import {animateInViewport} from './transition';

let jQueryBridget = require( 'jquery-bridget' );

$( function() {
	$( '.cf7dropzone .upload' ).html( 'Last opp filer' );
} );


let resizeTimer;

$( window ).on( 'resize', function() {
	clearTimeout( resizeTimer ); // Clear the previous timer

	resizeTimer = setTimeout( function() {
	}, 100 );
} );
